<template>
  <!-- 面包屑 开始 -->
  <el-breadcrumb class="my_breadcrumbs" separator-class="el-icon-arrow-right">
    <input type="hidden" :value="path">
    <el-breadcrumb-item v-for="(pathInfo, pathIndex) in pathList" :key="pathIndex" :to="pathIndex != 0 ? false:{ path: '../' + pathInfo }" :readonly="pathIndex!=0">
      <span class="my_breadcrumb">{{pathInfo}}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
  <!-- 面包屑 结束 -->
</template>

<script>
export default {
  name: 'MyBreadcrumb',
  props: ['path'],
  data () {
    return {
      pathList: []
    }
  },
  watch: {
    'path': function (newVal) {
      var path = newVal
      this.pathList = path.split('/')
      this.pathList.shift()
      this.pathList.shift()
    }
  }
}
</script>

<style scoped>
.my_breadcrumbs{
  /* border-left: 5px solid #333; */
  padding-left: 10px;
}
.my_breadcrumb{
  color: #fff;
  font-size: 18px;
  font-weight: bolder;
  /* margin-top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/MyBreadcrumb.vue